import { render, staticRenderFns } from "./AccountSetLayout.vue?vue&type=template&id=470d5ade"
import script from "./AccountSetLayout.vue?vue&type=script&lang=js"
export * from "./AccountSetLayout.vue?vue&type=script&lang=js"
import style0 from "./AccountSetLayout.vue?vue&type=style&index=0&id=470d5ade&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports